import { useEffect } from "react";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { viewTestimonials } from "../../states/actions/testimonialsAction";
import BaseUrl from "../../service/API/base_url";

const Testimonials = () => {
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
      {
        breakpoint: 10000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // dispatch
  const dispatch = useDispatch();

  // hooks
  const testimonials = useSelector((state) => state.testimonials);
  // use effect
  useEffect(() => {
    dispatch(viewTestimonials());
  }, []);

  return (
    <div className="py-10">
      <div className="container">
        {/* header section */}
        <div className="mb-6">
          <h1
            data-aos="fade-up"
            className="text-center text-2xl md:text-4xl font-bold font-cursive"
          >
            What our clients say
          </h1>
        </div>

        {/* Testimonial cards */}
        <div data-aos="zoom-in">
          <Slider {...settings}>
            {testimonials?.testimonials?.map((data, index) => (
              <div className="my-6">
                <div
                  key={index}
                  className="flex flex-col gap-4 shadow-lg py-8 px-6 mx-4 rounded-xl  bg-primary/10 relative"
                >
                  <div className="mb-4">
                    <img
                      src={`${BaseUrl}/${data?.photo}`}
                      alt="testimonial image"
                      className="rounded-full w-20 h-20"
                    />
                  </div>
                  {/* content section */}
                  <div className="flex flex-col items-center gap-4">
                    <div className="space-y-3">
                      <p className="text-xs text-gray-500">
                        {data?.clients_say}
                      </p>
                      <h1 className="text-xl font-bold text-black/80  font-cursive2">
                        {data?.full_Name}
                      </h1>
                    </div>
                  </div>
                  <p className="text-black/20 text-9xl font-serif absolute top-0 right-0">
                    ,,
                  </p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
